<template>
  <div class="bg-white rounded-lg border border-gray-200 p-3">
    <!-- Panel de filtros compacto -->
    <div class="rounded-lg bg-white p-2 shadow-sm">
      <!-- Fila 1: fechas + acciones -->
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 items-center">
        <!-- Desde -->
        <div class="lg:col-span-4">
          <!-- <label class="block text-[10px] font-semibold text-gray-600 mb-0.5">Desde</label> -->
          <input v-model.lazy="filtros.fechaDesde" type="datetime-local" :min="limiteMinimoDesde" :max="limiteMaximoDesde" :disabled="cargando" class="w-full h-8 px-2 border border-gray-300 rounded-lg bg-white text-xs
                   shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   disabled:opacity-60" />
        </div>

        <!-- Hasta -->
        <div class="lg:col-span-4">
          <!-- <label class="block text-[10px] font-semibold text-gray-600 mb-0.5">Hasta</label> -->
          <input v-model.lazy="filtros.fechaHasta" type="datetime-local" :min="limiteMinimoHasta" :max="limiteMaximoHasta" :disabled="cargando" class="w-full h-8 px-2 border border-gray-300 rounded-lg bg-white text-xs
                   shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   disabled:opacity-60" />
        </div>

        <!-- Acciones -->
        <div class="lg:col-span-4 flex items-center justify-start lg:justify-end gap-1.5">
          <button @click="actualizarGrafico" :disabled="cargando" class="h-8 px-3 rounded-lg text-xs font-semibold text-white
                   bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500
                   transition disabled:opacity-50 disabled:cursor-not-allowed">
            {{ cargando ? 'Cargando...' : 'Actualizar' }}
          </button>

          <button v-if="cargando" @click="cancelarPeticion" class="h-8 px-3 rounded-lg text-xs font-semibold text-white
                   bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition">
            Cancelar
          </button>
        </div>
      </div>

      <!-- Fila 2: presets + variables -->
      <div class="mt-2 flex flex-col lg:flex-row lg:items-center gap-2">
        <!-- Presets -->
        <div class="flex flex-wrap items-center gap-1 rounded-lg bg-gray-50 border border-gray-200 p-1">
          <button v-for="preset in presetsTimepo" :key="preset.key" @click="aplicarPreset(preset)" :disabled="cargando" class="h-7 px-2 rounded-lg text-xs font-medium
                   bg-white border border-gray-200 text-gray-700 shadow-sm
                   hover:bg-gray-50 hover:border-gray-300
                   focus:outline-none focus:ring-2 focus:ring-blue-500
                   disabled:opacity-50">
            {{ preset.nombre }}
          </button>
        </div>

        <!-- Variables -->
        <div class="lg:ml-auto flex flex-wrap items-center gap-1">
          <label v-for="variable in variablesDisponibles" :key="variable.key" class="group inline-flex items-center gap-1 h-7 px-2 rounded-lg
                   border border-gray-200 bg-white shadow-sm hover:bg-gray-50 cursor-pointer select-none">
            <input v-model="variablesActivas" :value="variable.key" type="checkbox" :disabled="cargando" class="w-3 h-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
            <span class="text-xs font-medium text-gray-700 whitespace-nowrap">
              {{ variable.nombre }}
            </span>
            <span class="w-1.5 h-1.5 rounded-full" :style="{ backgroundColor: variable.color }"></span>
          </label>

          <label class="inline-flex items-center gap-1 h-7 px-2 rounded-lg
                   border border-gray-200 bg-white shadow-sm hover:bg-gray-50 cursor-pointer select-none">
            <input v-model="mostrarEstados" type="checkbox" :disabled="cargando" class="w-3 h-3 rounded border-gray-300 text-purple-600 focus:ring-purple-500" />
            <span class="text-xs font-medium text-gray-700 whitespace-nowrap">Estados</span>
            <span class="w-1.5 h-1.5 rounded-full bg-purple-600"></span>
          </label>

          <label class="inline-flex items-center gap-1 h-7 px-2 rounded-lg
                   border border-gray-200 bg-white shadow-sm hover:bg-gray-50 cursor-pointer select-none">
            <input v-model="mostrarDeshielo" type="checkbox" :disabled="cargando" class="w-3 h-3 rounded border-gray-300 text-cyan-600 focus:ring-cyan-500" />
            <span class="text-xs font-medium text-gray-700 whitespace-nowrap">Deshielo</span>
            <span class="w-1.5 h-1.5 rounded-full bg-cyan-600"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Estadísticas compactas (solo si hay datos) -->
    <div v-if="estadisticas && hayDatos" class="mt-2 py-1 px-2 bg-gray-50 rounded-lg text-xs text-gray-600 flex flex-wrap items-center gap-x-3 gap-y-1">
      <span class="text-purple-600 font-medium">{{ estadisticas.totalPuntos || 0 }} puntos</span>
      <span class="text-gray-400">•</span>
      <span>{{ ultimaActualizacion }}</span>
      <span class="text-gray-400">•</span>
      <span class="text-purple-600">Promedios:</span>
      <span v-for="(promedio, variable) in estadisticas.promedios" :key="variable" class="text-purple-600">
        {{ obtenerNombreVariable(variable) }}: {{ promedio }}
      </span>
    </div>

    <!-- Mensaje de error -->
    <div v-if="error" class="mt-2 p-2 bg-red-50 border border-red-200 rounded-lg">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <svg class="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
          <span class="text-sm text-red-700">{{ error }}</span>
        </div>
        <div class="flex gap-2">
          <button @click="reintentar" class="px-2 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700">
            Reintentar
          </button>
          <button @click="usarDatosPrueba" class="px-2 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700">
            Datos de prueba
          </button>
        </div>
      </div>
    </div>

    <!-- Contenedor del gráfico -->
    <div class="relative mt-2">
      <div ref="chartContainer" :style="{ height: alturaGrafico + 'px' }" class="w-full border border-gray-100 rounded-lg"></div>

      <!-- Overlay de carga -->
      <div v-if="cargando" class="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center rounded-lg">
        <div class="text-center">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
          <div class="mt-1 text-xs text-gray-600 font-medium">{{ mensajeCarga }}</div>
          <div class="text-xs text-gray-500">{{ estadoCarga }}</div>
        </div>
      </div>

      <!-- Estado sin datos -->
      <div v-if="!cargando && !hayDatos && !error" class="absolute inset-0 flex items-center justify-center rounded-lg">
        <div class="text-center text-gray-500">
          <svg class="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <p class="text-base font-medium text-gray-700">Sin datos históricos</p>
          <p class="text-xs text-gray-500 mb-2">Ajusta los filtros y presiona "Actualizar"</p>
          <button @click="usarDatosPrueba" class="px-3 py-1.5 bg-gray-600 text-white text-xs rounded hover:bg-gray-700">
            Cargar datos de prueba
          </button>
        </div>
      </div>
    </div>

    <!-- Pie con información adicional (solo si hay datos) -->
    <!-- <div v-if="hayDatos"
      class="mt-2 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 text-xs text-gray-500">
      <div>Mostrando {{ totalPuntos }} puntos de datos</div>
      <div v-if="periodoMostrado">
        Período: {{ periodoMostrado.inicio }} - {{ periodoMostrado.fin }}
      </div>
    </div> -->
  </div>
</template>

<script>
let echarts = null
try {
  echarts = require('echarts')
} catch (error) {
  // ECharts no disponible, usando modo fallback
}

import { markRaw } from 'vue'
import DatosHistoricosService from '@/services/dispositivos/datosHistoricos.js'

export default {
  name: 'GraficoHistorial',

  props: {
    dispositivo: {
      type: Object,
      required: true,
      validator: (dispositivo) => dispositivo && dispositivo.id
    },
    configuracion: {
      type: Object,
      default: () => ({
        altura: 450,
        autoActualizar: false,
        intervaloActualizacion: 30000,
        maxPuntos: 1000,
        theme: 'light'
      })
    }
  },

  emits: ['datos-cargados', 'error', 'cambio-estado'],

  data() {
    return {
      echartsDisponible: !!echarts,
      cargando: false,
      mensajeCarga: '',
      estadoCarga: '',
      hayDatos: false,
      error: null,
      abortController: null,

      filtros: {
        fechaDesde: '',
        fechaHasta: ''
      },
      agregacion: 'minuto',
      alturaGrafico: 650,

      variablesDisponibles: [
        {
          key: 'tempRetorno',
          nombre: 'Temperatura Retorno',
          color: '#06b6d4'
        },
        {
          key: 'tempInyeccion',
          nombre: 'Temperatura Inyección',
          color: '#ef4444'
        },
        {
          key: 'tempExterior',
          nombre: 'Temperatura Exterior',
          color: '#10b981'
        }
      ],

      variablesActivas: ['tempRetorno', 'tempInyeccion'],
      mostrarEstados: true,
      mostrarDeshielo: true,

      datosChart: null,
      estadisticas: null,
      totalPuntos: 0,
      periodoMostrado: null,
      ultimaActualizacion: '',

      presetsTimepo: [
        { key: '1h', nombre: '1 hora', horas: 1 },
        { key: '4h', nombre: '4 horas', horas: 4 },
        { key: '12h', nombre: '12 horas', horas: 12 },
        { key: '24h', nombre: '24 horas', horas: 24 },
        { key: '3d', nombre: '3 días', horas: 72 },
        { key: '7d', nombre: '7 días', horas: 168 },
        { key: '45d', nombre: '45 días', horas: 1080 }
      ],

      intervalId: null,
      resizeObserver: null
    }
  },

  computed: {
    configuracionFinal() {
      return {
        altura: 450,
        autoActualizar: false,
        intervaloActualizacion: 30000,
        maxPuntos: 1000,
        theme: 'light',
        ...this.configuracion
      }
    },
    limiteMaximoDesde() {
      return this.filtros.fechaHasta || null;
    },
    limiteMinimoDesde() {
      if (!this.filtros.fechaHasta) return null;
      const fechaHasta = new Date(this.filtros.fechaHasta);
      fechaHasta.setDate(fechaHasta.getDate() - 45);
      return this.formatearFecha(fechaHasta);
    },
    limiteMinimoHasta() {
      return this.filtros.fechaDesde || null;
    },
    limiteMaximoHasta() {
      if (!this.filtros.fechaDesde) return null;
      const fechaDesde = new Date(this.filtros.fechaDesde);
      fechaDesde.setDate(fechaDesde.getDate() + 45);
      return this.formatearFecha(fechaDesde);
    }
  },

  mounted() {
    this.inicializar()
  },

  beforeUnmount() {
    this.limpiar()
  },

  watch: {
    dispositivo: {
      handler(nuevo, anterior) {
        if (nuevo?.id !== anterior?.id) {
          this.cargarDatos()
        }
      },
      immediate: false
    },
    variablesActivas: {
      handler() {
        if (this.hayDatos) {
          this.actualizarSeries()
        }
      }
    },
    mostrarEstados: {
      handler() {
        if (this.hayDatos) {
          this.actualizarSeries()
        }
      }
    },
    mostrarDeshielo: {
      handler() {
        if (this.hayDatos) {
          this.actualizarSeries()
        }
      }
    },
    'filtros.fechaDesde'(nuevoValor) {
      if (!nuevoValor || !this.filtros.fechaHasta) return;
      const desde = new Date(nuevoValor);
      const hasta = new Date(this.filtros.fechaHasta);
      const limiteMs = 45 * 24 * 60 * 60 * 1000;

      if (hasta - desde > limiteMs) {
        const nuevoHasta = new Date(desde);
        nuevoHasta.setDate(nuevoHasta.getDate() + 45);
        this.filtros.fechaHasta = this.formatearFecha(nuevoHasta);
      } else if (desde > hasta) {
        this.filtros.fechaHasta = nuevoValor;
      }
    },

    'filtros.fechaHasta'(nuevoValor) {
      if (!nuevoValor || !this.filtros.fechaDesde) return;
      const hasta = new Date(nuevoValor);
      const desde = new Date(this.filtros.fechaDesde);
      const limiteMs = 45 * 24 * 60 * 60 * 1000;

      if (hasta - desde > limiteMs) {
        const nuevoDesde = new Date(hasta);
        nuevoDesde.setDate(nuevoDesde.getDate() - 45);
        this.filtros.fechaDesde = this.formatearFecha(nuevoDesde);
      } else if (hasta < desde) {
        this.filtros.fechaDesde = nuevoValor;
      }
    }
  },

  methods: {
    cancelarPeticionSilenciosa() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
        this.finalizarCarga();
      }
    },
    determinarAgregacion() {
      if (!this.filtros.fechaDesde || !this.filtros.fechaHasta) {
        return 'minuto';
      }

      const inicio = new Date(this.filtros.fechaDesde);
      const fin = new Date(this.filtros.fechaHasta);
      const diffHoras = Math.abs(fin - inicio) / (1000 * 60 * 60);

      if (diffHoras <= 24) {
        return 'minuto';
      } else if (diffHoras <= 168) {
        return 'hora';
      } else {
        return 'dia';
      }
    },
    async inicializar() {
      try {
        this.configurarFechasDefecto()
        this.alturaGrafico = this.configuracionFinal.altura

        if (!this.echartsDisponible) {
          this.mostrarError('ECharts no está disponible. Instala ECharts: npm install echarts')
          return
        }

        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        await this.inicializarChart()
        this.configurarResponsividad()

        if (this.dispositivo?.id) {
          await this.cargarDatos()
        }

        if (this.configuracionFinal.autoActualizar) {
          this.iniciarAutoActualizacion()
        }

        this.$emit('cambio-estado', 'inicializado')

      } catch (error) {
        this.mostrarError(`Error de inicialización: ${error.message}`)
      }
    },

    async inicializarChart() {
      if (!this.$refs.chartContainer) {
        throw new Error('Container del gráfico no encontrado')
      }

      if (!echarts) {
        throw new Error('ECharts no está disponible')
      }

      try {
        const rect = this.$refs.chartContainer.getBoundingClientRect()
        if (rect.width === 0 || rect.height === 0) {
          this.$refs.chartContainer.style.width = '100%'
          this.$refs.chartContainer.style.height = this.alturaGrafico + 'px'
        }

        const instanciaEcharts = echarts.init(this.$refs.chartContainer, null, {
          renderer: 'canvas',
          useDirtyRect: true
        })
        this.chart = markRaw(instanciaEcharts)

        const opcionInicial = {
          title: {
            text: `Gráfico - ${this.dispositivo?.nombre_dispositivo || 'Dispositivo'}`,
            left: 'center',
            textStyle: {
              fontSize: 14,
              color: '#374151'
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            borderColor: '#e5e7eb',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#1f2937',
              fontSize: 13
            },
            padding: 12,
            confine: true,
            axisPointer: {
              type: 'cross',
              crossStyle: { color: '#999' }
            },
            formatter: this.tooltipFormatter
          },
          legend: {
            bottom: 10,
            textStyle: { fontSize: 12 }
          },
          grid: {
            left: '3%',
            right: '6%',
            bottom: '10%',
            top: '9%',
            containLabel: true
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              fontSize: 11,
              rotate: 45,
              formatter: function (value) {
                const date = new Date(value);
                const dia = String(date.getDate()).padStart(2, '0');
                const mes = String(date.getMonth() + 1).padStart(2, '0');
                const anio = String(date.getFullYear());
                const horas = String(date.getHours()).padStart(2, '0');
                const minutos = String(date.getMinutes()).padStart(2, '0');
                return `${dia}-${mes}-${anio} ${horas}:${minutos}`;
              },
              interval: 'auto',
              showMaxLabel: true,
              showMinLabel: true
            },
            splitLine: {
              show: true,
              lineStyle: { color: '#f0f0f0' }
            }
          },
          yAxis: [
            {
              type: 'value',
              name: ' ',
              position: 'left',
              nameTextStyle: {
                fontSize: 12,
                color: '#374151',
                padding: [0, 0, 0, -30]
              },
              axisLabel: {
                fontSize: 11,
                formatter: '{value}°C',
                color: '#374151'
              },
              splitLine: {
                show: true,
                lineStyle: { color: '#f0f0f0' }
              }
            },
            {
              type: 'value',
              name: 'Modo Operación',
              position: 'right',
              offset: 0,
              nameTextStyle: {
                fontSize: 12,
                color: '#a855f7',
                padding: [0, -20, 0, 0]
              },
              splitLine: { show: false },
              min: 0,
              max: 3,
              interval: 1,
              axisPointer: { show: false },
              axisLabel: {
                fontSize: 10,
                color: '#a855f7',
                formatter: function (value) {
                  const etiquetas = { 0: 'OFF', 1: 'FRIO', 2: 'CALOR', 3: 'VENTIL.' };
                  return etiquetas[value] || '';
                }
              }
            },
            {
              type: 'value',
              name: ' ',
              position: 'right',
              offset: 80,
              nameTextStyle: {
                fontSize: 12,
                color: '#06b6d4',
                padding: [0, -20, 0, 0]
              },
              splitLine: { show: false },
              min: 0,
              max: 1,
              interval: 1,
              axisPointer: { show: false },
              axisLabel: {
                fontSize: 10,
                color: '#06b6d4',
                formatter: function (value) {
                  return value === 1 ? 'ACTIVO' : 'INACTIVO';
                }
              }
            }
          ],
          series: []
        }

        this.chart.setOption(opcionInicial, true)

        this.chart.on('click', (params) => {
          console.log('Punto clickeado:', params)
        })

      } catch (error) {
        throw new Error(`No se pudo inicializar ECharts: ${error.message}`)
      }
    },

    tooltipFormatter(params) {
      if (!params || params.length === 0) return '';

      const tempParams = params.filter(param => param.seriesType === 'line' &&
        param.seriesName !== 'Modo Operación' &&
        param.seriesName !== 'Estado Deshielo');

      if (tempParams.length === 0) return '';

      const fecha = new Date(tempParams[0].value[0]).toLocaleString('es-CL', {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });

      let tooltipHtml = `<div style="font-family: -apple-system, sans-serif; min-width: 200px;">
                          <div style="font-size: 14px; font-weight: 600; margin-bottom: 10px; padding-bottom: 6px; border-bottom: 1px solid #eee; color: #111827;">
                            ${fecha}
                          </div>`;

      tempParams.sort((a, b) => a.seriesName.localeCompare(b.seriesName));

      tempParams.forEach(param => {
        tooltipHtml += `<div style="margin-top: 6px; display: grid; grid-template-columns: auto 1fr auto; align-items: center; font-size: 13px; gap: 8px;">
                          <span style="display: inline-block; width: 10px; height: 10px; border-radius: 2px; background-color: ${param.color};"></span>
                          <span style="color: #374151;">${param.seriesName}:</span>
                          <strong style="color: #000; font-size: 14px; text-align: right;">${param.value[1]}°C</strong>
                        </div>`;
      });

      tooltipHtml += '</div>';
      return tooltipHtml;
    },

    configurarFechasDefecto() {
      const ahora = new Date()
      // const hace24h = new Date(ahora.getTime() - (24 * 60 * 60 * 1000))
      const hace1h = new Date(ahora.getTime() - (1 * 60 * 60 * 1000))

      this.filtros.fechaHasta = this.formatearFecha(ahora)
      this.filtros.fechaDesde = this.formatearFecha(hace1h)
    },

    configurarResponsividad() {
      if (this.chart && window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
        this.resizeObserver.observe(this.$refs.chartContainer)
      }

      window.addEventListener('resize', this.redimensionarChart)
    },

    convertirAFormatoECharts(datosTemperaturas, datosEstadosHistoricos, datosDeshieloHistoricos) {
      const series = []
      const coloresVariables = {
        'tempRetorno': '#06b6d4',
        'tempInyeccion': '#ef4444',
        'tempExterior': '#10b981'
      }

      const puntosCombinados = this.combinarDatosOriginales(datosTemperaturas)

      this.variablesActivas.forEach(variable => {
        const varConfig = this.variablesDisponibles.find(v => v.key === variable)
        const datos = puntosCombinados
          .filter(punto => punto[variable] !== null && punto[variable] !== undefined)
          .map(punto => [punto.timestamp.getTime(), punto[variable]])

        if (datos.length > 0) {
          series.push({
            name: varConfig.nombre,
            type: 'line',
            smooth: false,
            symbol: 'none',
            yAxisIndex: 0,
            lineStyle: {
              width: 2,
              color: coloresVariables[variable] || '#666666'
            },
            itemStyle: {
              color: coloresVariables[variable] || '#666666'
            },
            data: datos
          })
        }
      })

      if (this.mostrarEstados && datosEstadosHistoricos && datosEstadosHistoricos.length > 0) {
        const datosModos = datosEstadosHistoricos.map(punto => [
          punto.timestamp.getTime(),
          punto.estado_numerico
        ])

        series.push({
          name: 'Modo Operación',
          type: 'line',
          step: 'end',
          yAxisIndex: 1,
          symbol: 'none',
          lineStyle: {
            width: 2.5,
            color: '#a855f7'
          },
          itemStyle: {
            color: '#a855f7'
          },
          data: datosModos
        })
      }

      if (this.mostrarDeshielo && datosDeshieloHistoricos && datosDeshieloHistoricos.length > 0) {
        const datosDeshielo = datosDeshieloHistoricos.map(punto => [
          punto.timestamp.getTime(),
          punto.deshielo_numerico
        ])

        series.push({
          name: 'Estado Deshielo',
          type: 'line',
          step: 'end',
          yAxisIndex: 2,
          symbol: 'none',
          lineStyle: {
            width: 2,
            color: '#06b6d4',
            type: 'dashed'
          },
          itemStyle: {
            color: '#06b6d4'
          },
          data: datosDeshielo,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: 'rgba(6, 182, 212, 0.3)'
              }, {
                offset: 1,
                color: 'rgba(6, 182, 212, 0.05)'
              }]
            }
          }
        })
      }

      const estadisticas = this.calcularEstadisticasOriginales(puntosCombinados)

      const periodo = puntosCombinados.length > 0 ? {
        inicio: Math.min(...puntosCombinados.map(p => p.timestamp.getTime())),
        fin: Math.max(...puntosCombinados.map(p => p.timestamp.getTime()))
      } : null

      const resultado = {
        series,
        estadisticas,
        totalPuntos: puntosCombinados.length,
        periodo
      }

      return resultado
    },

    validarRangoFechas() {
      const inicio = new Date(this.filtros.fechaDesde);
      const fin = new Date(this.filtros.fechaHasta);
      const msPorDia = 1000 * 60 * 60 * 24;
      const diffDias = Math.ceil(Math.abs(fin - inicio) / msPorDia);

      if (diffDias > 45) {
        this.mostrarError('El rango de fechas no puede superar los 45 días.');
        return false;
      }
      return true;
    },

    async cargarDatos() {
      if (!this.dispositivo?.id) {
        this.mostrarError('No hay dispositivo seleccionado')
        return
      }

      if (this.variablesActivas.length === 0 && !this.mostrarEstados && !this.mostrarDeshielo) {
        this.mostrarError('Selecciona al menos una variable, estados o deshielo para mostrar')
        return
      }

      if (!this.validarRangoFechas()) {
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }

      this.agregacion = this.determinarAgregacion();
      this.iniciarCarga()
      this.abortController = new AbortController()

      try {
        this.estadoCarga = 'Obteniendo datos históricos...'

        const datosCompletos = await DatosHistoricosService.obtenerDatosCompletosSecuencial(
          this.dispositivo.id,
          this.variablesActivas,
          new Date(this.filtros.fechaDesde),
          new Date(this.filtros.fechaHasta),
          this.agregacion,
          this.abortController.signal
        )

        this.estadoCarga = 'Procesando datos históricos...'

        const datosECharts = this.convertirAFormatoECharts(
          datosCompletos.temperaturas,
          datosCompletos.estados,
          datosCompletos.deshielo || []
        )

        await this.procesarDatos(datosECharts)
        this.finalizarCarga()

        this.$emit('datos-cargados', {
          dispositivo: this.dispositivo.id,
          puntos: this.totalPuntos,
          variables: this.variablesActivas
        })

      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Petición abortada');
          this.finalizarCarga();
        } else {
          this.mostrarError(error.message);
          this.finalizarCarga();
          this.$emit('error', error);
        }
      } finally {
        this.abortController = null;
      }
    },

    cancelarPeticion() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
        this.finalizarCarga();
        this.estadoCarga = 'Búsqueda cancelada';
        this.mostrarError('Petición cancelada por el usuario');
      }
    },

    combinarDatosOriginales(datosMultiples) {
      const puntosPorTimestamp = new Map()

      Object.entries(datosMultiples).forEach(([variable, datos]) => {
        if (Array.isArray(datos)) {
          datos.forEach(punto => {
            const timestamp = new Date(punto.timestamp || punto.fecha || punto.periodo)
            const key = timestamp.getTime()

            if (!puntosPorTimestamp.has(key)) {
              puntosPorTimestamp.set(key, {
                timestamp,
                _fuente: 'backend_original'
              })
            }

            const puntoExistente = puntosPorTimestamp.get(key)
            puntoExistente[variable] = punto.promedio ?? punto.valor ?? punto[variable] ?? null
          })
        }
      })

      return Array.from(puntosPorTimestamp.values())
        .sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime())
    },

    calcularEstadisticasOriginales(puntosCombinados) {
      const estadisticas = {
        promedios: {},
        rangos: {},
        totalPuntos: puntosCombinados.length
      }

      this.variablesActivas.forEach(variable => {
        const valores = puntosCombinados
          .map(punto => punto[variable])
          .filter(v => v !== null && v !== undefined && !isNaN(v))

        if (valores.length > 0) {
          estadisticas.promedios[variable] = (valores.reduce((sum, v) => sum + v, 0) / valores.length).toFixed(1)
          estadisticas.rangos[variable] = {
            min: Math.min(...valores).toFixed(1),
            max: Math.max(...valores).toFixed(1)
          }
        }
      })

      return estadisticas
    },

    async procesarDatos(datos) {
      this.datosChart = markRaw(datos)
      this.estadisticas = datos.estadisticas
      this.totalPuntos = datos.totalPuntos || 0

      if (datos.periodo) {
        const formatearDDMMYY = (timestamp) => {
          const d = new Date(timestamp);
          const dia = String(d.getDate()).padStart(2, '0');
          const mes = String(d.getMonth() + 1).padStart(2, '0');
          const anio = String(d.getFullYear()).slice(-2);
          const hrs = String(d.getHours()).padStart(2, '0');
          const mins = String(d.getMinutes()).padStart(2, '0');
          return `${dia}-${mes}-${anio} ${hrs}:${mins}`;
        };

        this.periodoMostrado = {
          inicio: formatearDDMMYY(datos.periodo.inicio),
          fin: formatearDDMMYY(datos.periodo.fin)
        }
      }

      if (this.chart && datos.series && datos.series.length > 0) {
        const opcion = {
          title: {
            text: `Gráfico - ${this.dispositivo?.nombre_dispositivo || 'Dispositivo'}`,
            left: 'center',
            textStyle: {
              fontSize: 14,
              color: '#374151'
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            borderColor: '#e5e7eb',
            borderWidth: 1,
            borderRadius: 8,
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 10,
            shadowOffsetY: 2,
            textStyle: {
              color: '#1f2937',
              fontSize: 13
            },
            padding: 12,
            confine: true,
            axisPointer: {
              type: 'cross',
              crossStyle: { color: '#999' }
            },
            formatter: this.tooltipFormatter
          },
          legend: {
            bottom: 10,
            textStyle: { fontSize: 12 }
          },
          grid: {
            left: '4%',
            right: '6%',
            bottom: '10%',
            top: '9%',
            containLabel: true
          },
          xAxis: {
            type: 'time',
            axisLabel: {
              fontSize: 11,
              rotate: 45,
              formatter: function (value) {
                const date = new Date(value);
                const dia = String(date.getDate()).padStart(2, '0');
                const mes = String(date.getMonth() + 1).padStart(2, '0');
                const anio = String(date.getFullYear());
                const horas = String(date.getHours()).padStart(2, '0');
                const minutos = String(date.getMinutes()).padStart(2, '0');
                return `${dia}-${mes}-${anio} ${horas}:${minutos}`;
              },
              interval: 'auto',
              showMaxLabel: true,
              showMinLabel: true
            },
            splitLine: {
              show: true,
              lineStyle: { color: '#f0f0f0' }
            }
          },
          yAxis: [
            {
              type: 'value',
              name: ' ',
              nameTextStyle: {
                fontSize: 12,
                color: '#374151',
                padding: [0, 0, 0, -30]
              },
              axisLabel: {
                fontSize: 11,
                formatter: '{value}°C',
                color: '#374151'
              },
              splitLine: {
                show: true,
                lineStyle: { color: '#f0f0f0' }
              }
            },
            {
              type: 'value',
              name: ' ',
              nameTextStyle: {
                fontSize: 12,
                color: '#a855f7',
                padding: [0, -30, 0, 0]
              },
              position: 'right',
              splitLine: { show: false },
              min: 0,
              max: 3,
              interval: 1,
              axisPointer: { show: false },
              axisLabel: {
                fontSize: 10,
                color: '#a855f7',
                formatter: function (value) {
                  const etiquetas = { 0: 'OFF', 1: 'FRIO', 2: 'CALOR', 3: 'VENTIL.' };
                  return etiquetas[value] || '';
                }
              }
            },
            {
              type: 'value',
              name: ' ',
              nameTextStyle: {
                fontSize: 12,
                color: '#06b6d4',
                padding: [0, -30, 0, 0]
              },
              position: 'right',
              offset: 60,
              splitLine: { show: false },
              min: 0,
              max: 1,
              interval: 1,
              axisPointer: { show: false },
              axisLabel: {
                fontSize: 10,
                color: '#06b6d4',
                formatter: function (value) {
                  return value === 1 ? 'ACTIVO' : 'INACTIVO';
                }
              }
            }
          ],
          series: datos.series
        }

        this.chart.setOption(opcion, true)
      }
      else if (this.chart) {
        /* Restablecer la instancia de ECharts cuando no existen datos en la consulta */
        this.chart.clear()
      }

      this.hayDatos = datos.series && datos.series.length > 0 && this.totalPuntos > 0
      this.ultimaActualizacion = new Date().toLocaleTimeString('es-CL')
    },

    actualizarSeries() {
      if (!this.chart || !this.datosChart) return

      const seriesFiltradas = this.datosChart.series.filter(serie => {
        if (serie.yAxisIndex === 0) {
          return this.variablesActivas.some(variable =>
            serie.name.toLowerCase().includes(variable.toLowerCase().replace('temp', ''))
          )
        }

        if (serie.yAxisIndex === 1) {
          return this.mostrarEstados
        }

        if (serie.yAxisIndex === 2) {
          return this.mostrarDeshielo
        }

        return false
      })

      this.chart.setOption({
        series: seriesFiltradas
      })
    },

    aplicarPreset(preset) {
      const ahora = new Date()
      const inicio = new Date(ahora.getTime() - (preset.horas * 60 * 60 * 1000))

      this.filtros.fechaHasta = this.formatearFecha(ahora)
      this.filtros.fechaDesde = this.formatearFecha(inicio)

      this.agregacion = this.determinarAgregacion()

      this.cargarDatos()
    },

    actualizarGrafico() {
      this.cargarDatos()
    },

    reintentar() {
      this.error = null
      this.cargarDatos()
    },

    async usarDatosPrueba() {
      this.iniciarCarga('Generando datos de prueba...')

      try {
        const datosPrueba = this.generarDatosPrueba()
        await this.procesarDatos(datosPrueba)
        this.finalizarCarga()

      } catch (error) {
        this.finalizarCarga()
      }
    },

    generarDatosPrueba() {
      const inicio = new Date(this.filtros.fechaDesde)
      const fin = new Date(this.filtros.fechaHasta)
      const intervalos = Math.min(50, Math.floor((fin - inicio) / (60 * 1000)))

      const series = []

      this.variablesActivas.forEach((variable, index) => {
        const varConfig = this.variablesDisponibles.find(v => v.key === variable)
        const datos = []

        for (let i = 0; i <= intervalos; i++) {
          const timestamp = inicio.getTime() + (i * 2 * 60 * 1000)
          const baseTemp = 20 + (index * 8)
          const variacion = Math.sin(i / 5) * 5 + (Math.random() - 0.5) * 3
          const temperatura = Math.round((baseTemp + variacion) * 10) / 10

          datos.push([timestamp, temperatura])
        }

        series.push({
          name: varConfig.nombre,
          type: 'line',
          smooth: false,
          symbol: 'none',
          symbolSize: 0,
          lineStyle: {
            width: 3,
            color: varConfig.color
          },
          itemStyle: {
            color: varConfig.color
          },
          data: datos
        })
      })

      if (this.mostrarEstados) {
        const datosModosPrueba = []
        let modoActual = 1

        for (let i = 0; i <= intervalos; i++) {
          const timestamp = inicio.getTime() + (i * 2 * 60 * 1000)

          if (i > 0 && Math.random() < 0.05) {
            const modosPosibles = [0, 1, 2, 3]
            modoActual = modosPosibles[Math.floor(Math.random() * modosPosibles.length)]
          }

          datosModosPrueba.push([timestamp, modoActual])
        }

        series.push({
          name: 'Modo Operación',
          type: 'line',
          step: 'end',
          yAxisIndex: 1,
          symbol: 'none',
          lineStyle: {
            width: 2.5,
            color: '#a855f7'
          },
          itemStyle: {
            color: '#a855f7'
          },
          data: datosModosPrueba
        })
      }

      if (this.mostrarDeshielo) {
        const datosDeshieloPrueba = []

        for (let i = 0; i <= intervalos; i++) {
          const timestamp = inicio.getTime() + (i * 2 * 60 * 1000)

          const enCicloDeshielo = Math.floor(i / 15) % 5 === 0 && (i % 15) < 3
          const deshielo = enCicloDeshielo ? 1 : 0

          datosDeshieloPrueba.push([timestamp, deshielo])
        }

        series.push({
          name: 'Estado Deshielo',
          type: 'line',
          step: 'end',
          yAxisIndex: 2,
          symbol: 'none',
          lineStyle: {
            width: 2,
            color: '#06b6d4',
            type: 'dashed'
          },
          itemStyle: {
            color: '#06b6d4'
          },
          data: datosDeshieloPrueba,
          areaStyle: {
            color: 'rgba(6, 182, 212, 0.2)'
          }
        })
      }

      const estadisticas = {
        promedios: {},
        rangos: {},
        totalPuntos: (intervalos + 1) * this.variablesActivas.length
      }

      this.variablesActivas.forEach(variable => {
        estadisticas.promedios[variable] = (22 + Math.random() * 8).toFixed(1)
        estadisticas.rangos[variable] = {
          min: (18 + Math.random() * 3).toFixed(1),
          max: (28 + Math.random() * 8).toFixed(1)
        }
      })

      const resultado = {
        series,
        estadisticas,
        totalPuntos: estadisticas.totalPuntos,
        periodo: {
          inicio: inicio.getTime(),
          fin: fin.getTime()
        }
      }

      return resultado
    },

    exportarImagen() {
      if (!this.chart) {
        this.mostrarError('Gráfico no disponible para exportar')
        return
      }

      try {
        const url = this.chart.getDataURL({
          type: 'png',
          pixelRatio: 2,
          backgroundColor: '#fff'
        })

        const nombreArchivo = `grafico_${this.dispositivo.nombre_dispositivo}_${new Date().toISOString().split('T')[0]}.png`

        const link = document.createElement('a')
        link.download = nombreArchivo
        link.href = url
        link.click()

      } catch (error) {
        this.mostrarError('Error exportando imagen')
      }
    },

    exportarCSV() {
      if (!this.datosChart || !this.datosChart.series.length) {
        this.mostrarError('No hay datos para exportar')
        return
      }

      try {
        const headers = ['Fecha/Hora']
        const datosParaCSV = new Map()

        this.datosChart.series.forEach(serie => {
          if (serie.yAxisIndex === 0) {
            headers.push(`${serie.name} (°C)`)
          } else if (serie.name === 'Modo Operación') {
            headers.push('Modo')
          } else if (serie.name === 'Estado Deshielo') {
            headers.push('Deshielo')
          }

          serie.data.forEach(punto => {
            const timestamp = punto[0]
            const valor = punto[1]

            if (!datosParaCSV.has(timestamp)) {
              datosParaCSV.set(timestamp, { timestamp: new Date(timestamp) })
            }

            let valorFormateado = valor
            if (serie.name === 'Modo Operación') {
              const mapeoModos = { 0: 'OFF', 1: 'FRIO', 2: 'CALOR', 3: 'VENTILACION' }
              valorFormateado = mapeoModos[valor] || valor
            } else if (serie.name === 'Estado Deshielo') {
              valorFormateado = valor === 1 ? 'ACTIVO' : 'INACTIVO'
            }

            datosParaCSV.get(timestamp)[serie.name] = valorFormateado
          })
        })

        const filas = Array.from(datosParaCSV.values())
          .sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime())
          .map(fila => {
            const csvFila = [fila.timestamp.toLocaleString('es-CL')]

            headers.slice(1).forEach(header => {
              let nombreSerie = header.replace(' (°C)', '').replace('Modo', 'Modo Operación').replace('Deshielo', 'Estado Deshielo')
              const valor = fila[nombreSerie]
              csvFila.push(valor !== undefined ? valor.toString().replace(',', '.') : '')
            })

            return csvFila.join(';')
          })

        const csvContent = '\uFEFF' + [headers.join(';'), ...filas].join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

        const nombreArchivo = `datos_${this.dispositivo.nombre_dispositivo}_${new Date().toISOString().split('T')[0]}.csv`

        const link = document.createElement('a')
        link.download = nombreArchivo
        link.href = URL.createObjectURL(blob)
        link.click()

      } catch (error) {
        this.mostrarError('Error exportando CSV')
      }
    },

    resetearZoom() {
      if (this.chart) {
        this.chart.dispatchAction({
          type: 'dataZoom',
          start: 0,
          end: 100
        })
      }
    },

    iniciarAutoActualizacion() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }

      this.intervalId = setInterval(() => {
        this.cargarDatos()
      }, this.configuracionFinal.intervaloActualizacion)
    },

    detenerAutoActualizacion() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },

    iniciarCarga(mensaje = 'Cargando datos históricos...') {
      this.cargando = true
      this.mensajeCarga = mensaje
      this.estadoCarga = 'Preparando consulta...'
      this.error = null
    },

    finalizarCarga() {
      this.cargando = false
      this.mensajeCarga = ''
      this.estadoCarga = ''
    },

    mostrarError(mensaje) {
      this.error = mensaje
      this.hayDatos = false
    },

    formatearFecha(fecha) {
      const YYYY = fecha.getFullYear();
      const MM = String(fecha.getMonth() + 1).padStart(2, '0');
      const DD = String(fecha.getDate()).padStart(2, '0');
      const HH = String(fecha.getHours()).padStart(2, '0');
      const mm = String(fecha.getMinutes()).padStart(2, '0');

      return `${YYYY}-${MM}-${DD}T${HH}:${mm}`;
    },

    obtenerNombreVariable(variable) {
      const varConfig = this.variablesDisponibles.find(v => v.key === variable)
      return varConfig ? varConfig.nombre : variable
    },

    redimensionarChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },

    limpiar() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.detenerAutoActualizacion()

      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }

      window.removeEventListener('resize', this.redimensionarChart)

      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
    }
  }
}
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.transition-colors {
  transition-property: background-color, border-color, color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
</style>